import { jsx as _jsx } from "react/jsx-runtime";
import { Flex } from '@coolblue-development/freddy';
import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
export const FlexWithGap = ({ children, isRightAligned }) => {
    return (_jsx(Flex, { columnGap: 100, wrap: "wrap", alignItems: "flex-end", justifyContent: isRightAligned ? 'flex-end' : 'flex-start', children: children }));
};
export const CurrentPrice = styled('span', {
    shouldForwardProp: prop => isPropValid(prop),
}) `
  ${({ size, isSubtle, theme }) => {
    switch (size) {
        case 'small':
            return `
          font-size: ${theme.typography.fontSize.md};
          font-weight: ${isSubtle ? 400 : 700};
          line-height: ${theme.typography.lineHeight[500]};
        `;
        case 'large':
            return `
          font-size: ${theme.typography.fontSize['3xl']};
          ${theme.breakpoint.minWidth('sm')} {
            font-size: ${theme.typography.fontSize['4xl']};
          }
          font-weight: 700;
          font-family: AvenirBlack, Arial, Helvetica, Verdana, sans-serif;
          line-height: ${theme.typography.lineHeight[600]};
        `;
        default:
            return `
          font-size: ${theme.typography.fontSize.xl};
          font-weight: ${isSubtle ? 400 : 700};
          line-height: ${theme.typography.lineHeight[500]};
        `;
    }
}};

  color: ${({ isSubtle, theme }) => (isSubtle ? theme.color.font.subtle : theme.color.font.base)};
`;
export const FormerPrice = styled('span', {
    shouldForwardProp: prop => isPropValid(prop),
}) `
  ${({ size, priceVariant, withoutStrikethrough, theme }) => {
    switch (size) {
        case 'small':
            return `
          font-size: ${theme.typography.fontSize.md};
          line-height: ${theme.typography.lineHeight[400]};
        `;
        case 'large':
            if (priceVariant !== 'business') {
                if (withoutStrikethrough) {
                    return `
              font-size: ${theme.typography.fontSize.xl};
              line-height: ${theme.typography.lineHeight[500]};
            `;
                }
                else {
                    return `
              font-size: ${theme.typography.fontSize['3xl']};
              ${theme.breakpoint.minWidth('sm')} {
                font-size: ${theme.typography.fontSize['4xl']};
              }
              line-height: ${theme.typography.lineHeight[600]};
            `;
                }
            }
            else {
                return `
            font-size: ${theme.typography.fontSize.xl};
            line-height: ${theme.typography.lineHeight[500]};
          `;
            }
        default:
            if (withoutStrikethrough) {
                return `
            font-size: ${theme.typography.fontSize.md};
            line-height: ${theme.typography.lineHeight[400]};
          `;
            }
            else {
                return `
            font-size: ${theme.typography.fontSize.xl};
            line-height: ${theme.typography.lineHeight[500]};
          `;
            }
    }
}};

  font-weight: 400;
  color: ${({ theme }) => theme.color.font.subtle};
`;
export const FreePrice = styled.span `
  font-weight: 700;
  font-size: ${({ theme }) => theme.typography.fontSize.md};
  color: ${({ theme }) => theme.color.font.accented};
`;
export const Price = styled('span', {
    shouldForwardProp: prop => isPropValid(prop),
}) `
  white-space: nowrap;
  position: relative;

  ${({ isFormerPrice, withoutStrikethrough, size, theme }) => isFormerPrice &&
    !withoutStrikethrough &&
    `
    ::before {
      border-top: ${size === 'small' ? '1px' : '2px'} solid ${theme.color.font.subtle};
      content: '';
      left: 0;
      position: absolute;
      right: 0;
      top: 50%;
      transform: rotate(-10deg);
      box-sizing: border-box;
    }
  `}
`;
export const FromText = styled('span', {
    shouldForwardProp: prop => isPropValid(prop),
}) `
  font-weight: ${({ size }) => (size === 'large' ? 400 : 700)};
  font-size: ${({ size, theme }) => size === 'medium' ? theme.typography.fontSize.xl : theme.typography.fontSize.md};
  line-height: ${({ theme }) => theme.typography.lineHeight[500]};
  color: ${({ isSubtle, theme }) => (isSubtle ? theme.color.font.subtle : theme.color.font.base)};
`;
export const PriceWithVAT = styled('span', {
    shouldForwardProp: prop => isPropValid(prop),
}) `
  ${({ size, theme }) => {
    switch (size) {
        case 'small':
            return `
          line-height: ${theme.typography.lineHeight[400]};
        `;
        case 'large':
            return `
          line-height: ${theme.typography.lineHeight[600]};
        `;
        default:
            return `
          line-height: ${theme.typography.lineHeight[500]};
        `;
    }
}};

  font-weight: 400;
  font-size: ${({ size, theme }) => size === 'small' ? theme.typography.fontSize.md : theme.typography.fontSize.xl};
  color: ${({ theme }) => theme.color.font.subtle};
`;
export const FormerPrefix = styled('span', {
    shouldForwardProp: prop => isPropValid(prop),
}) `
  font-weight: 400;
  font-size: ${({ size, theme }) => size === 'large' ? theme.typography.fontSize.md : theme.typography.fontSize.sm};
  line-height: ${({ size, theme }) => size === 'large' ? theme.typography.lineHeight[500] : theme.typography.lineHeight[400]};
  color: ${({ theme }) => theme.color.font.subtle};
`;
export const AdditionalText = styled('span', {
    shouldForwardProp: prop => isPropValid(prop),
}) `
  font-weight: 400;
  font-size: ${({ theme }) => theme.typography.fontSize.md};
  line-height: ${({ theme }) => theme.typography.lineHeight[500]};
  color: ${({ isSubtle, theme }) => (isSubtle ? theme.color.font.subtle : theme.color.font.base)};
`;
export const AlignedFlex = styled(Flex, {
    shouldForwardProp: prop => isPropValid(prop),
}) `
  justify-content: ${({ isRightAligned }) => (isRightAligned ? 'flex-end' : 'flex-start')};
  text-align: ${({ isRightAligned }) => (isRightAligned ? 'right' : 'left')};
  column-gap: 0.8rem;
`;
//# sourceMappingURL=SalesPrice.styled.js.map